var $1c47a7e4ae120674$exports = {};
$1c47a7e4ae120674$exports = {
    "invalidSelection": (args, formatter)=>`\u{6240}\u{9078}\u{7684}${formatter.plural(args.selectedCount, {
            one: `\u{65E5}\u{671F}`,
            other: `\u{65E5}\u{671F}`
        })}\u{7121}\u{6CD5}\u{4F7F}\u{7528}\u{3002}`
};


export {$1c47a7e4ae120674$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
